<template>
  <div class="d-tasks" @click.stop.prevent>
    <Loader v-if="isLoading" :isSmall="true"></Loader>
    <template v-else>
      <table class="d-table__inner">
        <thead>
        <tr>
          <th style="width: 75%">Tildelt arbejdstid</th>
          <th class="text-right">{{ tildeltArbejdstid }}</th>
        </tr>
        <tr>
          <th style="width: 75%">Tildelt Undervisningstid</th>
          <th class="text-right">{{ tildeltUndervisning }}</th>
        </tr>
        <tr>
          <th style="width: 75%">Tildelt Undervisningstid uden UUV</th>
          <th class="text-right">{{ tildeltUndervisningUdenUUV }}</th>
        </tr>
        </thead>
      </table>
      <table class="d-table__inner" v-for="(type, idx) in tasksInTypes">
        <thead class="d-table__inner__thead__small">
        <tr>
          <th style="width: 75%">
            {{ type.title }}
          </th>
          <th class="text-right">
            {{ type.sum }}
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-if="type.events.length < 1">
          <td class="text-explainer">Ingen <span v-if="idx === 0">lektioner</span><span v-if="idx === 1">UUV</span></td>
        </tr>
        <tr v-for="task in type.events">
          <td style="width: 75%">
            <div class="subject-and-calendar">
              <div class="d-subject" :style="{'border-left-color': task.color}">{{ task.name }}</div>
              {{ task.calendar }}
            </div>
          </td>
          <td class="text-right">{{ task.hours }}</td>
        </tr>
        </tbody>
      </table>
    </template>
  </div>
</template>

<script>
import docendo from '../../docendo'
import Loader from '../common/Loader'

export default {
  components: {Loader},
  props: {
    userId: {
      default: null
    },
    schoolYear: {},
    startDate: {},
    endDate: {}
  },
  data () {
    return {
      tasks: [],
      isLoading: true,
      tildeltArbejdstid: 0,
      tildeltUndervisning: 0
    }
  },
  computed: {
    tildeltUndervisningUdenUUV () {
      return (this.tildeltUndervisning * 1 - this.tasksInTypes[1].sum * 1).toFixed(1)
    },
    schoolId () {
      return this.$route.params.school_id
    },
    tasksInTypes () {
      let tasks = [
        {id: 'teaching', title: 'Fag', events: [], sum: 0},
        {id: 'supplemental', title: 'UUV', events: [], sum: 0}
      ]
      this.tasks.forEach(task => {
        if (task.master_type === 'teaching' && task.subject_type !== 'supplemental') {
          tasks[0].events.push(task)
          tasks[0].sum += task.hours * 1
        }
        if (task.subject_type === 'supplemental') {
          tasks[1].events.push(task)
          tasks[1].sum += task.hours * 1
        }
      })
      tasks[0].sum = tasks[0].sum.toFixed(1)
      tasks[1].sum = tasks[1].sum.toFixed(1)
      return tasks
    }
  },
  methods: {
    readUserTasks () {
      this.isLoading = true
      docendo.userTasks(this.userId, this.startDate, this.endDate, null, success => {
        this.isLoading = false
        this.tasks = success
      }, failure => {
        console.log(failure)
      })
      docendo.schoolAssignedHours(this.schoolId, this.schoolYear.name, [this.userId], data => {
        if (data && data.length === 1 && data[0]['assigned_total_hours']) {
          this.tildeltArbejdstid = data[0]['assigned_total_hours']
          this.tildeltUndervisning = data[0]['assigned_teaching_hours'] ? data[0]['assigned_teaching_hours'] : 0
        }
      }, failure => {
        console.log('failure', failure)
      })
    }
  },
  mounted () {
    this.readUserTasks()
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.d-tasks {
  position: absolute;
  z-index: 19990;
  top: calc(100% + 8px);
  left: 0;
  background-color: #fff;
  box-shadow: 0 3px 8px rgb(0 0 0 / 24%);
  height: auto;
  outline: none;
  text-align: left;
  min-width: 100px;
  width: 100%;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  margin-top: -10px !important;
  border-radius: 0 0 4px 4px;
  max-height: 80vh;
  overflow-y: auto;
  border: 1px solid var(--blue);
  border-width: 0 1px 1px 1px;
}

.d-table__inner {
  width: 100%;
  border-collapse: collapse;
  border-radius: 4px;
}

.d-table__inner thead {
  border-bottom: 1px solid #d8d8d8;
  background: #f6f9fc;
  color: #728195;
  text-transform: uppercase;
  border-radius: 4px;
  font-size: 11px;
}

.d-table__inner thead th {
  padding: 0.5rem 1rem;
  text-align: left;
}

.d-table__inner thead th.text-right {
  font-size: 12px;
}

.d-table__inner tbody tr {
  width: 100%;
  background: #f9fafb;
  border-bottom: 1px solid #e3e8ee;
  cursor: default;
}

.d-table__inner tbody tr:nth-child(odd) {
  background: #ffffff;
}

.d-table__inner tbody tr td {
  padding: 0.5rem 1rem;
  text-align: left;
  width: 75px !important;
  font-size: 11px;
}

.text-right {
  text-align: right !important;
}

.d-subject {
  position: relative;
  padding: 4px 6px;
  height: 30px;
  border-radius: 4px;
  word-break: break-all;
  overflow: hidden;
  text-align: left;
  margin: 2.5px 5px 2.5px 0;
  min-width: auto;
  font-weight: 700;
  transition: -webkit-transform .25s;
  transition: transform .25s;
  -webkit-animation: fadeIn;
  animation: fadeIn;
  width: 135px;
  background: #fff !important;
  color: #3e4450;
  box-shadow: none;
  border: 1px solid #d8d8d8;
  border-left: 2px solid transparent;
}

.subject-and-calendar {
  display: flex;
  align-items: center;
}

.d-table__inner__thead__small tr {
  background: #eee;
  font-size: 11px;
}

.d-table__inner__thead__small tr th {
  padding: 2px 1rem;
}

.d-table__inner__thead__small + tbody tr td {
  padding: 0.25rem 1rem;
}

</style>



// WEBPACK FOOTER //
// StilRessourceTasks.vue?07ff17d7